import React, {useEffect} from "react";
import {OverlayTrigger, Popover} from "react-bootstrap";
import {Link, useLocation} from "react-router-dom";
import {v4} from "uuid";

export default function StickyHelp() {
    const location=useLocation();

    useEffect(()=>{
    },[location])
    return <OverlayTrigger
        trigger="click"
        placement="top"
        key={v4()}
        overlay={
            <Popover id={`popover-positioned-top`}>
                <Popover.Content className="popover-content">
                    Find answers to frequently asked questions in our <Link to={"/faq"}>FAQ</Link> section.<br/>
                    In case you do not find what you<br/> are looking for, fill the form below<br/> and submit your
                    query.<br/>
                    <strong><a href="/contact-us">Click here!</a></strong>
                </Popover.Content>
            </Popover>
        }
    >
        <div className="sticky-help">
            <div className="sticky-help-child">
                <a className="font-weight-bold ">Need help?</a>
            </div>
        </div>
    </OverlayTrigger>


        ;
}